"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgChannelSms = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgChannelSms = function SvgChannelSms(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#sc_sms__paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M83 35V25C83 22.245 80.76 20 78 20H38C35.245 20 33 22.245 33 25V95C33 97.76 35.245 100 38 100H78C80.76 100 83 97.76 83 95V80H78V85H38V30H78V35H83Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M68 40H98C100.805 40 103 42.195 103 45V65C103 67.805 100.805 70 98 70H86.335L77 77C76.56 77.33 76.03 77.5 75.5 77.5C75.12 77.5 74.735 77.41 74.38 77.235C73.535 76.81 73 75.945 73 75V70H68C65.195 70 63 67.805 63 65V45C63 42.245 65.245 40 68 40Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "sc_sms__paint0_linear",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: 1,
    stopColor: "#DEAA00"
  }))));
};

exports.SvgChannelSms = SvgChannelSms;